import { useAppStateStore } from "@/features/application";
import type { PreferencesService } from "@/features/application/preferences";
import { storeToRefs } from "pinia";

export function usePreferencesUtilisateurService() {
    const { utilisateur } = storeToRefs(useAppStateStore())

    function getStorageKey() {
        if (!utilisateur.value) throw 'Utilisateur non connecté'
        return `akto.prefs.${utilisateur.value.userId}`
    }

    function loadAsync(): Promise<object> {
        const data = localStorage.getItem(getStorageKey())
        if (!data) return Promise.resolve({})
        return Promise.resolve(JSON.parse(data) as object)
    }

    function saveAsync(preferences: object): Promise<void> {
        localStorage.setItem(getStorageKey(), JSON.stringify(preferences))
        return Promise.resolve()
    }

    return {
        loadAsync,
        saveAsync
    } as PreferencesService
}